import React, { FC } from 'react'
import { Nomenclature } from 'entities/orders/model'
import { NomenclatureOldPriceLabel } from 'entities/bookings/ui/styles'
import { getNomenclatureDiscount } from 'entities/nomenclatures/model/utils'
import { NomenclaturesType } from 'entities/nomenclatures/model'

interface NomenclatureListPreviewItemProps {
    nomenclature: Nomenclature
}

export const NomenclatureListPreviewItem: FC<
    NomenclatureListPreviewItemProps
> = ({ nomenclature }) => {
    const { isDiscount, absolutDiscountTotal } =
        getNomenclatureDiscount(nomenclature)
    const priceLabel = nomenclature?.price
        ? nomenclature?.price - absolutDiscountTotal
        : nomenclature?.price

    return (
        <li>
            {nomenclature.name}{' '}
            {nomenclature.price && isDiscount ? (
                <>
                    <NomenclatureOldPriceLabel>
                        ₽{nomenclature.price}
                    </NomenclatureOldPriceLabel>{' '}
                    ₽{priceLabel}
                </>
            ) : (
                <>₽{nomenclature.price}</>
            )}{' '}
            ({nomenclature.count}{nomenclature.type === NomenclaturesType.AdditionalService ? 'ч' : 'шт'})
        </li>
    )
}
